import request from '@/utils/request'

/**
 * 2022-02-08 董浩
 * 获取各订单状态数量
 * WAITINF_FOR_PAYMENT("000", "待付款"),
 * WAITINF_FOR_DELIVERY("101", "待发货"),
 * DELIVERED("301", "已发货"),
 * COMPLETION("501", "已收货"),
 * CLOSED("601", "交易关闭"),
 * CANCELED("701", "已取消"),
 */
export function getOrderGroups() {
    return request({
        url: 'procurement/system/front/oms-orders/groups'
    })


}

/**
 * 获取账户明细
 * @param params 分页
 * @returns {*}
 */
export function getAccountBill(params) {
    return request({
        url: 'procurement/system/front/enterprise-balance-records/getAccountBill',
        params: params
    })
}

/**
 * 2022-02-08 董浩
 * 获取订单列表
 */
export function getOrderList(params) {
    return request({
        url: 'procurement/system/front/oms-orders/wx-pages',
        params
    })
}

/**
 * 2022-02-08 董浩
 * 取消订单
 */
export function cancelOrder(params) {
    return request({
        url: 'procurement/system/front/oms-orders',
        method: 'DELETE',
        params
    })
}

/**
 * 2022-02-08 董浩
 * 付款
 */
export function doPayOrder(params) {
    return request({
        url: 'procurement/system/front/oms-orders/pay',
        method: 'PUT',
        params
    })
}

/**
 * 2022-02-08 董浩
 * 确认收货
 */
export function confirmReceipt(params) {
    return request({
        url: 'procurement/system/front/oms-orders/confirm-receipt',
        params
    })
}

/**
 * 2022-02-08 董浩
 * 再来一单
 */
export function againOrder(params) {
    return request({
        url: 'procurement/system/front/oms-cart-items/copy',
        method: 'PUT',
        params
    })
}

/**
 * 2022-02-08 乔宁
 * 提交订单
 */
export function getOrder(data) {
    return request({
        url: 'procurement/system/front/oms-orders',
        method: 'POST',
        data
    })
}

/**
 * 2022-02-13 刘美玉
 * 获取订单列表
 */
export function getOrderDetails(params) {
    return request({
        url: '/procurement/system/front/oms-orders/wx-view',
        params
    })
}


/*
 *2023-02-14  刘美玉
 * 获取订单物流信息
 */
export function getLogistics(params) {
    return request({
        url: '/procurement/system/front/oms-delivery-infos/byOrderIdAllAndTraces',
        params
    })
}

/*
 *2023-04-17  刘美玉
 * 首营资料下载
 */
export function downloadZip(params) {
    return request({
        url: '/procurement/system/front/marketing-dossiers/zip',
        params,
				timeout: 60000,
    })
}